import { StarFilledIcon } from '@radix-ui/react-icons';
import { Image } from '@trashlab/sitesapp/src/components/shared/image';
import { Flex, Text, Box } from '@radix-ui/themes';
import { trpcWebsiteGetGoogleReviews } from '@trashlab/api/src/generated/hooks';
import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';

export const GoogleReviews = ({ dark = false }: { dark?: boolean }) => {
  const googleIcon = '/default/google-icon.svg';
  const { website } = useTenantContext();

  if (!website?.googlePlaceId || !website?.enableGoogleReviews) {
    return null;
  }

  const { data: googleData, isLoading } = trpcWebsiteGetGoogleReviews.useQuery(
    {
      placeId: website?.googlePlaceId,
      limit: 4,
      minRating: 4,
    },
    {
      enabled: !!(website?.googlePlaceId && website?.enableGoogleReviews),
      staleTime: 60 * 60 * 1000,
    },
  );

  if (!googleData || !googleData.reviews || googleData.reviews.length === 0) {
    return null;
  }

  return (
    <Box className="relative z-10">
      <Flex align="center" gap="2">
        <Image src={googleIcon} alt="Google Reviews" className="w-8 h-8" />
        <Flex direction="column" gap="0">
          <Flex gap="0.5">
            {[...Array(5)].map((_, i) => (
              <StarFilledIcon
                key={i}
                className={`w-5 h-5 ${
                  i < Math.round(googleData.averageRating ?? 0)
                    ? 'text-yellow-400'
                    : 'text-gray-300'
                }`}
              />
            ))}
          </Flex>
          <Text size="2" className={dark ? 'text-white' : 'text-gray-900'}>
            {googleData.totalReviews}+ Google Reviews
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default GoogleReviews;
